import { Badge } from 'react-bootstrap';

// Draft marker for KB managers (WEB-854). Only managers ever receive drafts
// from the API, and this renders nothing for published articles, so callers
// need no status or role checks of their own.
const ArticleStatusBadge = ({ status, className }) =>
  status === 'draft' ? (
    <Badge bg="warning" text="dark" className={className}>Draft</Badge>
  ) : null;

export default ArticleStatusBadge;